import React from "react";

function CubeIcon() {
  return (
    <svg
      width="38"
      height="41"
      viewBox="0 0 38 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.27 14.9579L19 20.0079L27.73 14.9579M19 30.0779V19.9979M28 23.9979V15.9979C27.9996 15.6472 27.9071 15.3028 27.7315 14.9991C27.556 14.6955 27.3037 14.4433 27 14.2679L20 10.2679C19.696 10.0924 19.3511 10 19 10C18.6489 10 18.304 10.0924 18 10.2679L11 14.2679C10.6963 14.4433 10.444 14.6955 10.2685 14.9991C10.0929 15.3028 10.0004 15.6472 10 15.9979V23.9979C10.0004 24.3487 10.0929 24.6931 10.2685 24.9968C10.444 25.3004 10.6963 25.5526 11 25.7279L18 29.7279C18.304 29.9035 18.6489 29.9959 19 29.9959C19.3511 29.9959 19.696 29.9035 20 29.7279L27 25.7279C27.3037 25.5526 27.556 25.3004 27.7315 24.9968C27.9071 24.6931 27.9996 24.3487 28 23.9979Z"
        stroke="#667085"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CubeIcon;
